import * as Product from '#/unified-rfqs/ui/rfqs/product-functions';

import { State } from '#/unified-rfqs/ui/rfq-builder/store';
import { PRODUCTS } from '#/products/config';
import { STRATEGIES } from '#/shared/strategies';
import { venueSupportsCustomStrategy } from '#/unified-rfqs/entities/products/venue';

const predefinedStrategies = Object.values(STRATEGIES);

const CUSTOM_STRATEGY_OPTION = {
  value: null,
  label: 'Custom',
  isDisabled: false,
};

export default function strategyView(
  selectedProductCode: State['productCode'],
  selectedStrategyCode: State['strategyCode'],
  selectedVenue: State['venue'],
) {
  const product =
    selectedProductCode != null ? PRODUCTS[selectedProductCode] : null;

  const predefinedOptions = predefinedStrategies
    .filter(
      (strategy) =>
        product != null && Product.supportsStrategy(product, strategy),
    )
    .map((strategy) => ({
      value: strategy.code,
      label: strategy.name,
    }));

  const options = venueSupportsCustomStrategy(selectedVenue)
    ? [...predefinedOptions, CUSTOM_STRATEGY_OPTION]
    : predefinedOptions;

  const selectedOption =
    options.find((option) => option.value === selectedStrategyCode) ?? null;

  return { options, selectedOption };
}
